'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  background: transparent url(', ') no-repeat right center;\n  background-size: 1em;\n  border: none;\n  outline: none;\n  opacity: .6;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  padding: 0.5em 0;\n  padding-right: 1.2em;\n  caret-color: #D266A0;\n  width: 100%;\n\n  & + div{\n    opacity: .6;\n    height: 2px;\n    background: ', ';\n    box-shadow: ', ';\n    position: relative;\n  }\n\n  &:hover, &:hover + div {\n    opacity: .8;\n  }\n\n  &:focus{\n    opacity: 1;\n    background: transparent;\n\n    & + div{\n      opacity: 1;\n      box-shadow: ', ';\n    }\n  }\n'], ['\n  background: transparent url(', ') no-repeat right center;\n  background-size: 1em;\n  border: none;\n  outline: none;\n  opacity: .6;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  padding: 0.5em 0;\n  padding-right: 1.2em;\n  caret-color: #D266A0;\n  width: 100%;\n\n  & + div{\n    opacity: .6;\n    height: 2px;\n    background: ', ';\n    box-shadow: ', ';\n    position: relative;\n  }\n\n  &:hover, &:hover + div {\n    opacity: .8;\n  }\n\n  &:focus{\n    opacity: 1;\n    background: transparent;\n\n    & + div{\n      opacity: 1;\n      box-shadow: ', ';\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _pencil = require('../../images/pencil.svg');

var _pencil2 = _interopRequireDefault(_pencil);

var _sharedStyles = require('../sharedStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

var StyledInput = _styledComponents2.default.input(_templateObject, _pencil2.default, _sharedStyles.linearGradient, _sharedStyles.activeBoxShadow, _sharedStyles.defaultBoxShadow);

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    var _temp, _this, _ret;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { focused: false }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Input.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: this.props.wrapClassName },
      _react2.default.createElement(StyledInput, _extends({}, this.props, {
        autoFocus: this.state.focused,
        type: 'text'
      })),
      _react2.default.createElement('div', null)
    );
  };

  return Input;
}(_react.Component);

exports.default = Input;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../thicket/packages/thicket-elements/lib/Input/index.js
// module id = 98
// module chunks = 2